import React, {useState} from "react";
import {Settings} from "../../../models/models";
import {PAYMENT_METHOD_PAGES} from "../../../constants";
import {NewPaymentMethodSection} from "./NewPaymentMethodSection";
import {useElements, useStripe} from "@stripe/react-stripe-js";

const PaymentMethodAddCardPage = (props: {settings: Settings, selectedPlan: Object, paymentIntentId: String,
    handleError: Function, setServerResponse: Function, setShouldRefresh: Function, setPage: Function
}) => {
    const {data, payNow, setPage, setShouldRefresh
    } = props;

    const {allPaymentMethods} = data;

    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(!payNow && (allPaymentMethods == null || allPaymentMethods.length === 0));

    return (
        <div className={"row"} data-testid={'paymentMethodAddCardPageDiv'}>
            <div className={"col-12"}>
                <NewPaymentMethodSection
                    stripe={stripe}
                    elements={elements}
                    loading={loading}
                    setLoading={setLoading}
                    onBack={() => setPage(PAYMENT_METHOD_PAGES.SPLASH)}
                    setShouldRefresh={setShouldRefresh}
                    setPage={setPage}
                    />
            </div>
        </div>
    );
};

export default PaymentMethodAddCardPage;